import { type MediaImageFragment } from '#graphql-operations'

export default function (episodeImage: MediaImageFragment | null, showImage: MediaImageFragment | null): MediaImageFragment | null | undefined {
  const image = episodeImage ?? showImage
  return image
}
